<template>
  <Card :title="$t('global.modify-master-domain')">
    <CardActionContent :buttons="getButtons()">
      <template #description>
        <div class="mb-3">{{ $t("global.modify-master-domain-desc") }}</div>
        <div>{{ $t("global.modify-master-domain-recommendation") }}</div>
        <Alert
          v-if="!site.isDomainAgnostic"
          variant="warning"
          :dismissible="false"
          class="mt-3 mb-0"
        >
          <div class="pb-2">{{ $t("global.modify-master-domain-conditions") }}</div>
          <ol type="a">
            <li>{{ $t("global.modify-master-domain-condition-1") }}</li>
            <li>{{ $t("global.modify-master-domain-condition-2") }}</li>
            <li>{{ $t("global.modify-master-domain-condition-3") }}</li>
          </ol>
        </Alert>
      </template>
    </CardActionContent>
  </Card>
</template>

<script>
import Alert from "@/components/display/Alert";
import Card from "@/components/display/Card";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import ModifyMasterDomainModal from "@/components/smart/modals/ModifyMasterDomain";
import NavLink from "@/classes/NavLink";
import store from "@/store";

export default {
  name: "ChangeMasterDomain",
  components: {
    Alert,
    Card,
    CardActionContent,
  },
  props: {
    isPrimarySite: {
      type: Boolean,
      required: true,
    },
    site: Object,
  },
  setup(props, { root }) {
    const changeMasterDomain = () => {
      store.dispatch("modals/open", {
        template: ModifyMasterDomainModal,
        data: { site: props.site },
      });
    };

    const enabled = () => isFlexiblePrimarySite() || props.site.canChangeDomain;
    const isFlexiblePrimarySite = () => isFlexible() && props.isPrimarySite;
    const isFlexible = () => props.site?.app?.type === "generic";

    const getButtons = () => [
      new NavLink(
        root.$t("global.modify-master-domain"),
        "edit",
        changeMasterDomain,
        false,
        null,
        "epsilon",
        !enabled()
      ),
    ];

    return {
      getButtons,
    };
  },
};
</script>
